module.exports = __webpack_public_path__ + "static/profilePic-9120e6e6f638567392304bf13a266ef2.jpg";